import './App.css';
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Mobile from './Mobile';
import Desktop from './Desktop';

const router = createBrowserRouter([
    {
      path: "/",
      element: <Mobile />,
    },
    {
      path: "/desktop",
      element: <Desktop />,
    }
]);

function App() {
    return (
        <RouterProvider router={router} />
    );
}

export default App;
